import { useEffect, useState } from "react";

// 腾讯云验证码
export const useTencentCaptcha = () => {
  // 验证码对象
  const [captchaObj, setCaptchaObj] = useState();
  // 验证码结果
  const [captchaErrorCode, setCaptchaErrorCode] = useState();
  const [captchaRandStr, setCaptchaRandStr] = useState("");
  const [captchaTicket, setCaptchaTicket] = useState("");

  // 重置验证码结果
  const resetCaptchaRes = () => {
    setCaptchaErrorCode(undefined);
    setCaptchaRandStr("");
    setCaptchaTicket("");
  };

  // 定义回调函数
  const callback = (res) => {
    // 第一个参数传入回调结果，结果如下：
    // ret         Int       验证结果，0：验证成功。2：用户主动关闭验证码。
    // ticket      String    验证成功的票据，当且仅当 ret = 0 时 ticket 有值。
    // CaptchaAppId       String    验证码应用ID。
    // bizState    Any       自定义透传参数。
    // randstr     String    本次验证的随机串，后续票据校验时需传递该参数。
    // res（用户主动关闭验证码）= {ret: 2, ticket: null}
    // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
    // res（请求验证码发生错误，验证码自动返回terror_前缀的容灾票据） = {ret: 0, ticket: "String", randstr: "String",  errorCode: Number, errorMessage: "String"}
    // 此处代码仅为验证结果的展示示例，真实业务接入，建议基于ticket和errorCode情况做不同的业务处理
    if (res.ret === 0) {
      const {ticket, randstr, errorCode} = res;

      // 处理验证失败时，返回错误码
      if (errorCode) {
        setCaptchaErrorCode(errorCode);
      }

      setCaptchaRandStr(randstr);
      setCaptchaTicket(ticket);
    }
  };

  // 定义验证码js加载错误处理函数
  const loadErrorCallback = () => {
    const appid = "189974576";
    // 生成容灾票据或自行做其它处理
    const ticket =
      "terror_1001_" + appid + "_" + Math.floor(new Date().getTime() / 1000);
    callback({
      ret: 0,
      randstr: "@" + Math.random().toString(36).substr(2),
      ticket: ticket,
      errorCode: 1001,
      errorMessage: "jsload_error",
    });
  };

  // 验证码初始化
  const captchaInit = async () => {
    try {
      // 生成一个验证码对象
      // callback：定义的回调函数
      const captcha = new TencentCaptcha("189974576", callback);
      setCaptchaObj(captcha);
    } catch (error) {
      // 加载异常，调用验证码js加载错误处理函数
      loadErrorCallback();
    }
  };

  // 校验验证码
  const showCaptcha = () => {
    if (!captchaObj) return;

    captchaObj.show();
  };

  // 初始化验证码对象
  useEffect(() => {
    captchaInit();
  }, []);

  return {
    showCaptcha,
    resetCaptchaRes,
    captchaRandStr,
    captchaTicket,
    captchaErrorCode,
  };
};
